<template>
    <vx-table class="xl:grid-cols-10-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Campaign ID</div>
            <div>Source</div>
            <div>Brand</div>
            <div>Brand Trust</div>
            <div>Use Case</div>
            <div>Status</div>
            <div>AT&T Class</div>
            <div>Numbers</div>
            <div>Synced</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
